<template>
  <b-modal
    header-bg-variant="info"
    header-text-variant="light"
    ref='frequently-asked-questions'
    id='frequently-asked-questions'
    size='xl'
    scrollable
    hide-footer
    hide-header
    @show="showModal()"
  >
    <section class='modal-font-family modal-add-category'>
      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class=' w-100'
      >
        <section class="header">
          <section>
            <p v-if="frequentlyAskedQuestions && frequentlyAskedQuestions._id" class='mt-2'>
              Editar de questão
            </p>
            <p v-else class='mt-2'>
              Cadastro de questão
            </p>
          </section>

          <section>
            <b-icon
              style='cursor: pointer'
              @click='hideModalFrequentlyAskedQuestions()'
              class='ml-1'
              font-scale='2.5'
              icon='x'
              color='#262626'
            >
            </b-icon>
          </section>
        </section>

        <section class="mt-2">
          <section>
            <label>Título da questão</label>
            <base-input-text
              v-model="frequentlyAskedQuestions.title"
              type="text"
              placeholder="Digite o título da questão aqui"
            />
          </section>
          <section class="mt-4">
            <label>Corpo da questão</label>
            <quill-editor v-model='frequentlyAskedQuestions.body'></quill-editor>
          </section>
        </section>


        <section class="mt-4">
          <b-alert
            show
            variant='danger'
            :class='{ hidden: !errors }'
          >
            {{ errors }}
          </b-alert>
          <section class="mt-3 w-100">
            <button
              v-if="frequentlyAskedQuestions && frequentlyAskedQuestions._id"
              @click="update()"
              class="w-100"
            >
              <strong class="mr-3">Clique para editar</strong>
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.172 9.49992L-3.83699e-07 9.49992L-2.96276e-07 7.49992L12.172 7.49992L6.808 2.13592L8.222 0.721923L16 8.49992L8.222 16.2779L6.808 14.8639L12.172 9.49992Z"
                  fill="#022245" />
              </svg>
            </button>

            <button
              v-else
              @click="create()"
              class="w-100"
            >
              <strong class="mr-3">Clique para cadastrar</strong>
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.172 9.49992L-3.83699e-07 9.49992L-2.96276e-07 7.49992L12.172 7.49992L6.808 2.13592L8.222 0.721923L16 8.49992L8.222 16.2779L6.808 14.8639L12.172 9.49992Z"
                  fill="#022245" />
              </svg>
            </button>
          </section>
        </section>
      </b-overlay>
    </section>
  </b-modal>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'FrequentlyAskedQuestions',
  data() {
    return {
      loading: false,
      frequentlyAskedQuestions: {
        title: null,
        body: null,
        categoryId: null,
        _id: null
      }
    }
  },
  created() {

  },
  async mounted() {
  },
  props: {
    frequentlyAskedQuestionsId: { type: String, required: false, default: null },
    categoryId: { type: String, required: false, default: null },
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    errors() {
      return this.$store.getters['access/error']
    }
  },
  methods: {
    ...mapActions('frequentlyAskedQuestions', {
      handleCreate: 'handleCreate',
      handleUpdate: 'handleUpdate',
      handleGet: 'handleGet'
    }),
    async showModal() {
      try {
        this.frequentlyAskedQuestions = {
          title: null,
          body: null,
          categoryId: null,
          _id: null
        }
        if(this.categoryId){
          setTimeout(() => {
            this.frequentlyAskedQuestions.categoryId = this.categoryId
          }, 100)
        }

        this.loading = false
        if (this.frequentlyAskedQuestionsId) {
          await this.get()
        }

        await this.$store.dispatch('access/updateError', ``)
      } catch (e) {

      }
    },

    async create() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        if (!this.frequentlyAskedQuestions.title) {
          await this.$store.dispatch('access/updateError', `Digite o título da questão!`)
          return
        }
        if (!this.frequentlyAskedQuestions.body) {
          await this.$store.dispatch('access/updateError', `Digite o Corpo da questão!`)
          return
        }
        this.loading = true
        const { data, status, errors } = await this.handleCreate(this.frequentlyAskedQuestions)

        this.loading = false
        this.hideModalFrequentlyAskedQuestions()
        this.$emit('reload', {})
        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
      } catch (e) {

      }
    },

    async get() {
      try {
        this.loading = true
        const { data: response } = await this.handleGet(this.frequentlyAskedQuestionsId)
        const { data } = response
        this.frequentlyAskedQuestions = data
        this.loading = false
      } catch (e) {

      }
    },

    async update() {
      try {
        await this.$store.dispatch('access/updateError', ``)
        await this.$store.dispatch('access/updateError', ``)
        if (!this.frequentlyAskedQuestions.title) {
          await this.$store.dispatch('access/updateError', `Digite o título da questão!`)
          return
        }
        if (!this.frequentlyAskedQuestions.body) {
          await this.$store.dispatch('access/updateError', `Digite o Corpo da questão!`)
          return
        }
        this.loading = true
        const { data, status, errors } = await this.handleUpdate(this.frequentlyAskedQuestions)

        this.loading = false
        this.hideModalFrequentlyAskedQuestions()
        this.$emit('reload', {})
        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
      } catch (e) {

      }
    },

    hideModalFrequentlyAskedQuestions() {
      this.$bvModal.hide('frequently-asked-questions')
    }
  }
}
</script>

<style lang='scss' scoped>
.modal-add-category {
  .header {
    display: flex;
    align-content: start;
    justify-content: space-between;

    p {
      font-size: 20px;
      font-weight: 700;
      color: #262626;
    }
  }

  label {
    font-size: 16px;
    font-weight: 700;
    color: #808080;
  }

  button {
    background: #CBD63E;
    border: none;
    padding: 10px 20px;
    font-weight: 700;
    font-size: 17px;
    color: var(--navy-blue);
  }
}
</style>